import { gql, useLazyQuery } from "@apollo/client";
import { ListGoodQuery, ListGoodQueryVariables } from "../gql/graphql";

const LIST_GOOD_QUERY = gql`
  query listGood($input: ListGoodInput!) {
    listGood(input: $input) {
      ok
      err
      goods {
        id
        price
        status
        discountRate
        title
        summary
        tags
        corporation {
          id
          name
        }
        goodPosters {
          id
          upload {
            url
          }
        }
        goodReviews {
          id
        }
        goodOptions {
          id
          createdAt
          name
          count
          price
          isActive
          discountRate
          desc
          corporation {
            id
            name
          }
        }
      }
    }
  }
`;

export const useListGood = (onCompleted?: (data: ListGoodQuery) => void) => {
  return useLazyQuery<ListGoodQuery, ListGoodQueryVariables>(LIST_GOOD_QUERY, {
    onCompleted,
    fetchPolicy: "network-only",
  });
};
